import { CHARACTER_SKILL_LABELS } from '../ui/ui-labels';

export const SKILL_COLORS = Object.freeze({
  sales: Object.freeze({
    primary: 0xfde047, // Bright Yellow
    secondary: 0xf97316, // Warm Orange
    accent: 0xffffff, // White
    deadlineRed: 0xef4444, // Red for deadline penalty
    deadlineYellow: 0xfacc15,
  }),
  developer: Object.freeze({
    primary: 0x38bdf8, // Sky Cyan
    secondary: 0xa855f7, // Muted Purple
    darkPurple: 0x7c3aed,
    terminalGreen: 0x4ade80,
    accent: 0xffffff, // White
  }),
});

export const SKILL_NAMES = Object.freeze({
  salesSkill1: CHARACTER_SKILL_LABELS.sales.skill1,
  salesSkill2: CHARACTER_SKILL_LABELS.sales.skill2,
  devSkill1: CHARACTER_SKILL_LABELS.developer.skill1,
  devSkill2: CHARACTER_SKILL_LABELS.developer.skill2,
});

export type SkillHitEffectKind =
  | 'SALES_SKILL1_HIT'
  | 'SALES_SKILL1_FINISH'
  | 'SALES_SKILL2_HIT'
  | 'DEV_COUNTER_HIT'
  | 'DEV_TRAP_HIT';

export const resolveSkillHitEffect = (
  attackId: string,
  hitId?: string,
): { kind: SkillHitEffectKind; color: number; size: number } | null => {
  const normAttack = attackId.toLowerCase();
  const normHit = (hitId ?? '').toLowerCase();

  // Sales Skill 1 (二枚舌ラッシュ) - 3-hit multi-attack
  if (normHit === 'sales_s1_3') {
    return { kind: 'SALES_SKILL1_FINISH', color: SKILL_COLORS.sales.primary, size: 54 };
  }
  if (normHit === 'sales_s1_1' || normHit === 'sales_s1_2' || (normAttack.includes('skill-1') && normAttack.includes('sales'))) {
    return { kind: 'SALES_SKILL1_HIT', color: SKILL_COLORS.sales.secondary, size: 40 };
  }

  // Sales Skill 2 (無理な納期設定)
  if (normAttack.includes('skill-2') && normAttack.includes('sales')) {
    return { kind: 'SALES_SKILL2_HIT', color: SKILL_COLORS.sales.deadlineRed, size: 56 };
  }

  // Developer Skill 1 Counter Hit (仕様変更カウンター反撃)
  if (normAttack.includes('counter-response') || normHit.includes('developer-counter-hit')) {
    return { kind: 'DEV_COUNTER_HIT', color: SKILL_COLORS.developer.primary, size: 64 };
  }

  // Developer Skill 2 Trap Hit (スパゲッティコード Trap)
  if (normAttack.includes('trap') && normAttack.includes('developer')) {
    return { kind: 'DEV_TRAP_HIT', color: SKILL_COLORS.developer.secondary, size: 48 };
  }

  return null;
};
